import { type GroupBase, type SelectComponentsConfig, components } from 'react-select';

import type { Country } from '../../../features/geography/types';
import { CountryCodeDisplay } from '../CountryCodeDisplay/CountryCodeDisplay';

export const Placeholder: SelectComponentsConfig<
  Country,
  false,
  GroupBase<Country>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
>['Placeholder'] = ({ children, ...props }) => (
  <components.Placeholder {...props}>
    <CountryCodeDisplay type="placeholder" />
  </components.Placeholder>
);
